import React from "react";

interface Props {
  height?: number;
  width?: number | string;
  className?: string;
}

export default function SkeletonBlock({
  height = 16,
  width,
  className = ""
}: Props) {
  return (
    <div
      className={`v-fade-in animate-pulse bg-zinc-200 rounded ${className}`}
      style={{ height, width }}
    />
  );
}
